import React from 'react';
import { FullScreenButtonContent } from '../../../constans/polls-constants';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import fullscreenIcon from '../../../assets/icons/fullscreen.svg';
import fullscreenExitIcon from '../../../assets/icons/fullscreen_exit.svg';

interface IProps {
  buttonStateContent: FullScreenButtonContent;
  actionHandler?: () => void;
}

const FullScreenButton: React.FC<IProps> = ({ buttonStateContent, actionHandler }) => {
  const imageSrc = buttonStateContent === FullScreenButtonContent.OPEN ? fullscreenIcon : fullscreenExitIcon;
  const buttonlassName = buttonStateContent === FullScreenButtonContent.OPEN ? 'open' : 'exit';

  return (
    <TransparentButton customClasses={`full-screen-button ${buttonlassName}`} onClick={actionHandler}>
      <img src={imageSrc} alt='Full screen icon'/>
      {buttonStateContent}
    </TransparentButton>
  );
};

export default FullScreenButton;